const CHAT_FILE_EXTENSION_BY_MIME = {
  "application/pdf": "pdf",
  "application/msword": "doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
  "application/vnd.ms-excel": "xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
  "application/vnd.ms-powerpoint": "ppt",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
  "application/zip": "zip",
  "application/x-rar-compressed": "rar",
  "application/octet-stream": "bin",
  "text/plain": "txt",
  "text/csv": "csv",
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/gif": "gif",
  "image/webp": "webp",
  "image/svg+xml": "svg",
  "audio/mpeg": "mp3",
  "audio/mp4": "m4a",
  "video/mp4": "mp4",
};

const getSafeFileName = (fileName) => {
  if (typeof fileName !== "string") return "";
  return fileName.trim().split(/[\\/]/).pop() || "";
};

export const getChatFileExtension = (fileName, contentType) => {
  const safeFileName = getSafeFileName(fileName);
  const dotIndex = safeFileName.lastIndexOf(".");

  if (dotIndex > 0 && dotIndex < safeFileName.length - 1) {
    return safeFileName.slice(dotIndex + 1).toLowerCase();
  }

  const normalizedContentType = contentType?.toLowerCase().split(";")[0].trim();
  const mappedExtension = CHAT_FILE_EXTENSION_BY_MIME[normalizedContentType];
  if (mappedExtension) return mappedExtension;

  const subtype = normalizedContentType?.split("/").pop();
  return subtype && /^[a-z0-9]{1,10}$/.test(subtype) ? subtype : "bin";
};

export const getChatFileDownloadName = (chatId, fileName, contentType) => {
  const safeFileName = getSafeFileName(fileName);
  if (safeFileName) return safeFileName;

  return `file_${chatId}.${getChatFileExtension(null, contentType)}`;
};
